module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('ul', {
    staticClass: "menu-list"
  }, [_vm._m(0), _vm._v(" "), (_vm.accountType == 'vendor') ? [(_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n                    Stats\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('a', {
    attrs: {
      "aria-expanded": _vm.leadsMenu.expanded
    },
    on: {
      "click": function($event) {
        _vm.leadsMenu.expanded = !_vm.leadsMenu.expanded
      }
    }
  }, [_vm._m(1), _vm._v("\n                    Leads\n                    "), _vm._m(2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leadsMenu.expanded),
      expression: "leadsMenu.expanded"
    }]
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customersList.length),
      expression: "customersList.length"
    }],
    staticClass: "sub-menu"
  }, _vm._l((_vm.customersList), function(item, index) {
    return _c('li', {
      staticClass: "menu-item"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.generatePath('leads', item),
        "exact": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-right"
    }), _vm._v(" " + _vm._s(item.name) + "\n                                ")])], 1)
  }), 0)])])], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.accountType == 'customer') ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" Home\n                ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "aria-expanded": _vm.leadsMenu.expanded
    },
    on: {
      "click": function($event) {
        _vm.leadsMenu.expanded = !_vm.leadsMenu.expanded
      }
    }
  }, [_vm._m(3), _vm._v("\n                    Leads\n                    "), _vm._m(4)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leadsMenu.expanded),
      expression: "leadsMenu.expanded"
    }]
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashboardList.length),
      expression: "dashboardList.length"
    }],
    staticClass: "sub-menu"
  }, _vm._l((_vm.dashboardList), function(item, index) {
    return _c('li', {
      staticClass: "menu-item"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.generatePath('dashboards', item),
        "exact": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-right"
    }), _vm._v(" " + _vm._s(item.name) + "\n                                ")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sidebar-buttons"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": function($event) {
        return _vm.$emit('showDashboardModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" New\n                            ")])])])])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "aria-expanded": _vm.analyticsMenu.expanded
    },
    on: {
      "click": function($event) {
        _vm.analyticsMenu.expanded = !_vm.analyticsMenu.expanded
      }
    }
  }, [_vm._m(5), _vm._v("\n                    Analytics\n                    "), _vm._m(6)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.analyticsMenu.expanded),
      expression: "analyticsMenu.expanded"
    }]
  }, [_c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/model-stats"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Models\n                                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/agents-stats"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Agents\n                                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/agents-slots"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Slots\n                                ")])], 1)])])])], 1), _vm._v(" "), (_vm.epicEnabled) ? _c('li', [_c('a', {
    attrs: {
      "aria-expanded": _vm.epicMenu.expanded
    },
    on: {
      "click": function($event) {
        _vm.epicMenu.expanded = !_vm.epicMenu.expanded
      }
    }
  }, [_vm._m(7), _vm._v("\n                    EPIC\n                    "), _vm._m(8)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.epicMenu.expanded),
      expression: "epicMenu.expanded"
    }]
  }, [_c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/epic/clients"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Clients\n                                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/epic/policies"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Policies\n                                ")])], 1)])])])], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "aria-expanded": _vm.campaignsMenu.expanded
    },
    on: {
      "click": function($event) {
        _vm.campaignsMenu.expanded = !_vm.campaignsMenu.expanded
      }
    }
  }, [_vm._m(9), _vm._v("\n            Campaigns\n            "), _vm._m(10)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.campaignsMenu.expanded),
      expression: "campaignsMenu.expanded"
    }]
  }, [_c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/campaigns"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Active Campaigns")])])], 1), _vm._v(" "), (_vm.showPostingInstructions) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/campaigns-docs"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Posting Instructions")])])], 1) : _vm._e()])])])], 1)], 2), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 copyright"
  }, [_c('small', [_c('i', {
    staticClass: "fa fa-copyright",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" LeadScorz " + _vm._s(new Date().getFullYear()))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "brand text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/logo_small.png",
      "alt": "LeadScorz",
      "title": "LeadScorz"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "brandname"
  }, [_vm._v("LeadScorz")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-line-chart",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-angle"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-angle"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-flask",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-angle"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-database",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-angle"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-angle"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bcbf858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Sidebar.vue
// module id = 670
// module chunks = 0